import BaseModelAPI from '../BaseModelAPI';

export default class DispositionList extends BaseModelAPI {

	static entity = 'dispositionlist'
	static entityName = 'disposition';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
